import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChallengesSection from "@/components/ChallengesSection";
import FAQ from "@/components/FAQ";
import ContactForm from "@/components/ContactForm";
import ScrollProgress from "@/components/ScrollProgress";
import EvaluationProcess from "@/components/EvaluationProcess";
import Payouts from "@/components/Payouts";

export default function ChallengesPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="challenges-page" className="relative overflow-x-hidden">
      <ScrollProgress />
      <Navbar />

      <section className="relative pt-32 pb-12 overflow-hidden">
        <div className="absolute inset-0 bg-grid bg-grid-fade animate-grid-pulse pointer-events-none opacity-60" />
        <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="pill-mono inline-flex mb-5">{t("challengesPage.eyebrow", "Plans · Real Plan IDs")}</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight mb-5">
              {t("challengesPage.title1", "Pick Your")} <span className="text-gradient-brand font-semibold">{t("challengesPage.titleAccent", "Challenge")}</span>
            </h1>
            <p className="text-zinc-400 max-w-2xl mx-auto text-base">
              {t("challengesPage.lede", "Three programmes. Four trading platforms. Account sizes from $5K to $250K. Every Buy Now button below routes to the correct planID on our dashboard.")}
            </p>
          </motion.div>
        </div>
      </section>

      <ChallengesSection />
      <EvaluationProcess />
      <Payouts />
      <FAQ />
      <ContactForm />
      <Footer />
    </div>
  );
}
